import { render, staticRenderFns } from "./link-wrapper.vue?vue&type=template&id=20fd12de&scoped=true&"
import script from "./link-wrapper.vue?vue&type=script&lang=js&"
export * from "./link-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./link-wrapper.vue?vue&type=style&index=0&id=20fd12de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd12de",
  null
  
)

export default component.exports